import React from 'react'
import LogoComplete from './images/paserg/paserg-logo-complete.png'
import LogoColors from './images/paserg/paserg-background-colors.png'
import LogoLeaves from './images/paserg/paserg-border-leaves.png'
import LogoInsignia from './images/paserg/paserg-border-insignia.png'
import LogoText from './images/paserg/paserg-border-text.png'
import LogoTree from './images/paserg/paserg-border-tree.png'
import BSALogo from './images/paserg/paserg-bsa-logo.png'

import './Paserg.css'

const logoTransformationStart = 50
const logoTransformationEnd = 250

/* Trickery to have the animations happen on scroll */
const pasergScrollListener = (e) => {
    const headerElement = document.querySelector('.paserg-header')
    const logoElement = document.querySelector('.paserg-logo-container')
    const leavesElement = document.querySelector('.paserg-container .leaves')
    const scrollPosition = window.scrollY

    if(!leavesElement || !logoElement) {
        return;
    }

    if(!leavesElement.classList.contains('scrolled')) {
        leavesElement.classList.add('scrolled')

        window.setTimeout(()=> {
            logoElement.classList.add('animation-complete')
        }, 3000)
    }

    if(scrollPosition < logoTransformationStart) {
        logoElement.style.transform = 'translate3d(0, 0, 0) scale(1)'
        return
    }

    if(scrollPosition >= logoTransformationEnd) {
        logoElement.style.transform = `translate3d(35vw, -100px, 0) scale(0.3)`
        return
    } 

    const animationProgress = (scrollPosition - logoTransformationStart) / (logoTransformationEnd - logoTransformationStart)
    logoElement.style.transform = 
        `translate3d(${35 * animationProgress}vw, ${-100 * animationProgress}px, 0) scale(${1 - 0.7 *animationProgress})`


}

window.setTimeout(() => {
    // TODO: we are firing the leaves animation immediately because there isn't enough content to reliably scroll.
    window.addEventListener('scroll', pasergScrollListener)
    // For now, just trigger the animation
    pasergScrollListener()
}, 500)

/* end onScroll trickery */

const Accordion = ({heading, children}) => {
    return (
        <div className='paserg-accordion'>
            <h2 onClick={(e) => {
                e.target.closest('.paserg-accordion').classList.toggle('expanded')
            }}>
                {heading}
            </h2>
            <div className='accordion-children'>
                {children}
            </div>
        </div>
    )
}


const Paserg = () => {

    return (
        <div className='paserg-container'>
            <section className='paserg-header'>
                <div className='paserg-logo-container'>
                    <img className='paserg-logo-complete' src={LogoComplete} />
                    <div className='paserg-logo-composite'>
                        <img className='background' src={LogoColors} />
                        <img className='leaves' src={LogoLeaves} />
                        <img className='tree'  src={LogoTree} />
                        <img className='logo-text' src={LogoText} />
                        <img className='logo-insignia' src={LogoInsignia} />
                    </div>
                </div>
            </section>
            <section className='paserg-body'>
                <div className='paserg-title'>
                    <h1>Pan-African Social Ecology Reading Group</h1>
                </div>
                {/*<Accordion heading='Test Accordion'>
                    <p>Contents of the accordion</p>
    </Accordion>*/}
                <p>
                    The Pan-African Social Ecology Reading Group (PASERG) is the next step towards our goal of expanding mass political 
                    education amongst the African Diaspora world wide. We aim to create a space for communal study, a living, 
                    breathing, evolving dialectic to counter the atomized, isolating variation encouraged in academia – study as 
                    a collaborative activity in opposition to its function under capitalism in order to break the grip of hierarchy, 
                    statist ideologies, and domination in our thinking and organizing. 
                </p>
                <Accordion heading="Code of Conduct">
                    <ul>
                        <li>Challenge ideas, not people – Be respectful of each other.</li>
                        <li>Embrace a beginner's mindset – This is a learning environment.</li>
                        <li>Respect the agenda and facilitators.</li>
                        <li>"One Mic" – Refrain from talking over and interrupting others.</li>
                        <li>Regulate yourself and W.A.I.T. (Ask yourself: Why am I talking? Why am I quiet?).</li>
                        <li>Be mindful of privilege (gender, class, sexuality, education, etc.).</li>
                        <li>Be present in the group AND attentive to your needs (e.g., mute yourself, go off camera, nourish your body as needed).</li>
                    </ul>
                    <hr />
                    <p>Come as you are.</p>
                    <p>Everyone has something to learn and contribute.</p>
                    <p>This space is open to all black/African people on the path of their political development, no matter their place within that journey.</p>
                    <p>We intend to engage with works predominately developed by our ancestors, forebears, and contemporaries within Black diasporic thought. Throughout history, the oppressed peoples of the world have drawn inspiration and, at times, intertwined their struggles with that of African peoples the world over. Yet, to this day, the thoughts of Black revolutionaries are still the most disregarded by our supposed allies. We seek to reverse this trend and cultivate space to radically grapple with these texts with one another in hopes of distilling a greater clarity.</p>
                    <p>With that made clear, naturally we won't be reduced to only discussing works by Black authors because we center black thought in the space. We deem it of vital importance to foster an environment where all works with liberatory potential can be digested and critiqued through our collective lens.   </p>
                </Accordion>
                <Accordion heading="Readings and Schedule">
                    <p><a target="_blank" rel="noreferrer" href="https://social-ecology.org/wp/wp-content/uploads/2019/10/Social-Ecology-Pamphlet-Emily-McGuire.pdf">Emily McGuire - Social Ecology</a></p>
                    <p><a target="_blank" rel="noreferrer" href="https://theanarchistlibrary.org/library/kuwasi-balagoon-a-soldier-s-story">Kuwasi Balagoon - A Soldier’s Story</a></p>
                    <p><a target="_blank" rel="noreferrer" href="https://theanarchistlibrary.org/library/kazembe-balagun-kuwasi-at-60">Kazembe Balagun - Kuwasi at 60</a></p>
                    <p><a target="_blank" rel="noreferrer" href="https://theanarchistlibrary.org/library/kuwasi-balagoon-autobiography-1971">Kuwasi Balagoon - From “Look for Me in the Whirlwind”</a></p>
                    <p><a target="_blank" rel="noreferrer" href="https://roarmag.org/essays/the-stories-we-need-pan-african-social-ecology/">Eleanor Finley - The stories we need: pan-African social ecology</a></p>
                    <hr />
                    <ul>
                        <li>Week 1. Social Ecology Pamphlet + “Introduction” & “BLA”</li>
                        <li>Week 2. “Kuwasi in the 21st Century”</li>
                        <li>Week 3. “Poetry” + “Kuwasi Speaks(KS): In the Other Army & Statement”</li>
                        <li>Week 4. “KS: Brinks Trial”</li>
                        <li>Week 5. “KS: Destroy - A Letter to Overthrow Newspaper”</li>
                        <li>Week 6. “Letters” + “Found and Shared” Part 1</li>
                        <li>Week 7.  “Found and Shared” Part 2,3,4</li>
                        <li>Week 8. “Kuwasi Remembered” + Group Reflection</li>
                    </ul>
                </Accordion>
                <a className="paserg-cta" target="_blank" rel="noreferrer" href="https://cryptpad.fr/form/#/2/form/view/mbS9iwvT5h8sY9vAHodwimYTzhgfJAvG2+Xh1dU5VJc/">
                    Apply to Join
                </a>
                <a className="paserg-home-link" href="/">Return to Home Page</a>
                <img className='paserg-logo-insignia-footer' src={BSALogo} />
            </section>
        </div>
    )
}

export default Paserg;


// WEBPACK FOOTER //
// ./src/pages/Paserg.js